import React from "react";
import "./style.less";

export const Loading = ({ message = "Loading..." }) => {
  return (
    <div className="Loading">
      <div className="Loading__spinner" />
      <div className="Loading__text">{message}</div>
    </div>
  );
};
